import React, { Fragment } from "react";
import TextInput from "../../common/TextInput";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AutoComplete from "../../common/AutoComplete";
import Row from "../../common/Row";
import NumberInput from "../../common/NumberInput";


const AdresFormItem = (props, context) => {

    const {
        model,
        onChange,
        errors
    } = props;



    return (
        <Fragment>
            <Row>
                <TextInput
                    name="straat"
                    label="Straat"
                    value={model.straat}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['straat'] : ""}
                />

                <NumberInput
                    name="huisnummer"
                    label="Huisnummer (optioneel)"
                    value={model.huisnummer}
                    originalValue={model.huisnummer}
                    dontParse
                    onChange={onChange}
                    size={3}
                    validationMessage={errors ? errors['huisnummer'] : ""}
                />

                <TextInput
                    name="bus"
                    label="Bus (optioneel)"
                    value={model.bus}
                    onChange={onChange}
                    size={3}
                    validationMessage={errors ? errors['bus'] : ""}
                />
            </Row>
            <Row>
                <AutoComplete
                    items={props.postcodes || []}
                    size={3}
                    name="postcode"
                    label="Postcode"
                    value={model.postcode}
                    onChange={onChange}
                    validationMessage={errors ? errors['postcode'] : ""}
                />

                <AutoComplete
                    items={props.gemeentes || []}
                    size={9}
                    name="gemeente"
                    label="Gemeente"
                    value={model.gemeentes}
                    onChange={onChange}
                    validationMessage={errors ? errors['gemeente'] : ""}
                />
            </Row>
        </Fragment>


    );
};

AdresFormItem.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func,
    gemeentes: PropTypes.array,
    postcodes: PropTypes.array,
    errors: PropTypes.array
};

function mapStateToProps(state, ownProps) {
    return {
        postcodes: state.referentie.postcodes,
        gemeentes: state.referentie.gemeentes
    };
}


export default connect(mapStateToProps)(AdresFormItem);